
/* injects from baggage-loader */
require('./style.styl');

import React, {Component} from 'react'
import PropTypes from 'prop-types'
import without from 'lodash/without'
import {DragDropContext} from 'react-dnd'
import HTML5Backend from 'react-dnd-html5-backend'

import Item from './Item'
import Multiselect from 'components/Multiselect'

class MetricsMultiselect extends Component {
  static propTypes = {
    options: PropTypes.array.isRequired,
    values: PropTypes.array,
    onChange: PropTypes.func,
    placeholder: PropTypes.string,
    groupKey: PropTypes.string,
    groupTitleKey: PropTypes.string
  }

  constructor(props) {
    super(props)
    this.state = {
      hoveredValue: null
    }
  }

  render() {
    const {values, options, placeholder, groupKey, groupTitleKey} = this.props

    return (
      <div className='metrics-multiselect'>
        {this.renderItems()}
        <Multiselect
          options={this.getValues(options)}
          values={values}
          onChange={this.onApplyValues}
          placeholder={placeholder}
          groupKey={groupKey}
          groupTitleKey={groupTitleKey}
        />
      </div>
    )
  }

  renderItems() {
    const {hoveredValue} = this.state
    const values = this.getValues()

    if (!values || !values.length) return null

    return values
      .map(({value, label, variants, disabled}, index) => (
        <Item
          hovered={hoveredValue === value}
          label={label}
          disabled={disabled}
          variants={variants}
          onMouseEnter={() => this.setState({hoveredValue: value})}
          onMouseLeave={() => this.setState({hoveredValue: null})}
          onDelete={this.onItemDelete(value, variants)}
          index={index}
          key={value}
          moveItem={this.onMoveItem}
        />
      )
      )
  }

  onApplyValues = selectedValues => {
    const {options, values, onChange} = this.props
    const existingValues = values.filter(val => selectedValues.includes(val))
    const newValues = without(selectedValues, ...existingValues)
    const filteredValues = options.filter(opt => newValues.includes(opt.value)).map(item => item.value)
    const newItems = existingValues.concat(filteredValues).map(item => options.find(opt => opt.value === item))
    const resultValues = this.getValues(newItems).reduce((acc, item) => {
      if (!item.variants) return acc.concat(item.value)
      return acc.concat(item.variants.map(v => v.value))
    }, [])

    onChange && onChange(resultValues)
  }

  onItemDelete = (value, variants) => () => {
    const {values, onChange} = this.props

    if (!onChange) return false

    if (variants) {
      onChange(without(values.concat(), ...variants.map(item => item.value)))
    } else {
      onChange(without(values.concat(), value))
    }
  }

  onMoveItem = (dragIndex, hoverIndex) => {
    const {onChange} = this.props
    const values = this.getValues()
    const dragItem = values[dragIndex]

    const newValues = values.concat()
    newValues.splice(dragIndex, 1)
    newValues.splice(hoverIndex, 0, dragItem)

    onChange && onChange(newValues.reduce((acc, item) => {
      if (item.variants) {
        return acc.concat(item.variants.map(variant => variant.value))
      }
      return acc.concat(item.value)
    }, []))
  }

  getValues(passedItems) {
    const {values, options} = this.props
    const items = passedItems || values.map(value => options.find(item => item.value === value))
    const mappedGroups = {}

    return items.reduce((acc, item) => {
      const {variantGroup} = item

      if (variantGroup && mappedGroups[variantGroup]) return acc

      if (variantGroup) {
        const groupItems = items.filter(i => i.variantGroup === variantGroup)
        const firstGroupEl = groupItems[0]
        mappedGroups[variantGroup] = true
        return acc.concat({
          ...firstGroupEl,
          label: firstGroupEl.metricLabel,
          selected: !!groupItems.find(i => i.selected),
          groupMain: true,
          variants: groupItems
            .map(({variantLabel, value, selected, disabled}) => ({
              label: variantLabel,
              disabled,
              value,
              selected,
              isVariant: true
            }))
        })
      }

      return acc.concat(item)
    }, [])
  }
}

export default DragDropContext(HTML5Backend)(MetricsMultiselect)



// WEBPACK FOOTER //
// ./client/components/MetricsMultiselect/index.js